import { render, staticRenderFns } from "./discount-row-fees.vue?vue&type=template&id=bc5e5ed4&scoped=true"
import script from "./discount-row-fees.vue?vue&type=script&lang=js"
export * from "./discount-row-fees.vue?vue&type=script&lang=js"
import style0 from "./discount-row-fees.vue?vue&type=style&index=0&id=bc5e5ed4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc5e5ed4",
  null
  
)

export default component.exports